<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <h2>Faturas</h2>
      <p>
        Fique em dia com suas faturas e retire aqui sempre sua via atualizada.
        Lembre-se, boleto venceu? Sempre retire um novo aqui.
      </p>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-img
        class="d-none d-md-block"
        fluid
        :src="require('@/assets/images/pages/calendar-illustration.png')"
      />
    </b-col>
    <b-col
      cols="12"
      class="mt-0"
    >
      <b-card>
        <list-minhas-faturas />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import ListMinhasFaturas from './ListMinhasFaturas.vue'

export default {
  components: {
    ListMinhasFaturas,
  },
}
</script>
